import { createAsyncThunk } from "@reduxjs/toolkit";
import statisticApi from "api/statisticApi";
import { formatQueryParams } from "helpers/format";
import { changeStatusBlockIPAction, changeStatusBlockUUIDAction } from "./reducer";

export const ipStatistics = createAsyncThunk("Statistics", async (params: any = {}) => {
  try {

  } catch (error) {
    return error;
  }
});

